export default __webpack_public_path__ + "static/char-s-17-en-764f07d18c5c278cae22167d25fe05a1.png";